import { useContext } from "react";
import { UploadLockContext } from "./UploadLockContext";

export function useUploadLock() {
  return useContext(UploadLockContext);
}
